import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import { useToast, useProcessing } from "../../../context/ui-feedback-context";
import { actualizarKanban, crearKanban } from "../../../api/api-kanban";
import SendRequestComponent from "../../../components/btn-request";
import SwitchComponent from "../../../components/switch";

export default function KanbanViajePage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");
  const { showToast } = useToast();
  const { showProcessing, hideProcessing } = useProcessing();

  const [sendRequest, setSendRequest] = useState(false);


  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const charLimits = {
    codigo: 64,
    descripcion: 128,
    nota: 512,
    orden: 3,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let next = value;

    if (name === "orden") {
      next = value.replace(/\D/g, "");
    }

    const limit = charLimits[name];
    if (limit == null || next.length <= limit) {
      setFormData({
        ...formData,
        [name]: next,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (String(formData.orden).trim().length === 0) {
        message = message + t("alert_debe_ingresar_orden") + '\n';
      }
      if (isNaN(formData.orden)) {
        message = message + t("alert_debe_ingresar_orden_numerico") + '\n';
      }
      if (message.length > 0) {
        showToast(message, "error");
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const handleSaveClick = async () => {
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.codigo = formData.codigo;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.orden = formData.orden;
    objEnviar.esteEstadoIniciaViaje = formData.esteEstadoIniciaViaje;
    objEnviar.idTablero = 'viaje';
    showProcessing();
    if (formData.id === 0) {
      const response = await crearKanban(objEnviar);
      hideProcessing();
      if (response.error === false) {
        showToast(t("alert_se_creo_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_crear"));
      }
    }
    if (formData.id !== 0) {
      const response = await actualizarKanban(objEnviar);
      hideProcessing();
      if (response.error === false) {
        showToast(t("alert_se_modifico_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_modificar"));
      }
    }
  };

  const render = () => {
    try {
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={formData.codigo}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nombre"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={formData.descripcion}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.descripcion.length}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="orden"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_orden")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="orden"
                  name="orden"
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={formData.orden ?? ""}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.orden}
                  placeholder={t("placeholder_ingresa_orden")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.orden.length}/{charLimits.orden}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="esteEstadoIniciaViaje"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_este_estado_inicia_viaje")}?
                </label>
                <SwitchComponent
                  checked={formData?.esteEstadoIniciaViaje ?? false}
                  onChange={(checked) => setFormData({ ...formData, esteEstadoIniciaViaje: checked })}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  <SendRequestComponent
                    loading={sendRequest}
                    label={t("label_guardar")}
                    onClick={handleSaveClick}
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
